import type { ReactNode } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { LanguageToggle, useT } from './i18n';

// Shared shell for every authenticated screen: a top header with app title,
// signed-in user, and sign-out, plus an <Outlet /> where the active route
// renders. Screens added in tasks 16.3-16.7 render inside this layout via the
// nested routes declared in routes.tsx, so navigation chrome lives in one
// place.
export function AppLayout(): ReactNode {
  const auth = useAuth();
  const { t } = useT();
  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="app-title-link">
          <h1>{t('app.title')}</h1>
        </Link>
        <nav className="app-header-nav">
          <Link to="/api-keys">{t('nav.apiKeys')}</Link>
        </nav>
        <div className="app-header-user">
          <LanguageToggle />
          <span>{auth.user?.username}</span>
          <button type="button" onClick={() => void auth.signOut()}>
            {t('auth.signOut')}
          </button>
        </div>
      </header>
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
